import React, { useState } from 'react'
import NoteContext from './NoteContext'

const NoteState = (props) => {
    const host = 'https://webnote.onrender.com'
    const [notes, setNotes] = useState([])

    // Fetch Notes

    async function fetchallnotes() {
        const response = await fetch(`${host}/api/auth/fetchallnotes`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": localStorage.getItem('token')
            },
        });
        const json = await response.json();
        setNotes(json.notes);
    }


    async function addnote(title, description, tag) {
        const response = await fetch(`${host}/api/auth/addnote`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": localStorage.getItem('token')
            },
            body: JSON.stringify({ title, description, tag }),
        });
    
        const json = await response.json();
    
        if (response.ok) {
            return json; // Resolve the promise with the JSON response
        } else {
            throw new Error(json.errors); // Reject the promise with the error message
        }
    }
    



    async function deletenote(id) {
        const response = await fetch(`${host}/api/auth/deleteNote/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "auth-token": localStorage.getItem('token')
            },
        });
        const json = response.json();
        return json
    }

    async function editnote(title, description, tag, id) {
        const response = await fetch(`${host}/api/auth/updateNote/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "auth-token": localStorage.getItem('token')
            },
            body: JSON.stringify({ title, description, tag }),
        });
        const json = await response.json();
        if (json.success) 
        {
        let newNotes = JSON.parse(JSON.stringify(notes))
        for (let index = 0; index < newNotes.length; index++) {
            const element = newNotes[index];
            if (element._id === id) {
                newNotes[index].title = title;
                newNotes[index].description = description;
                newNotes[index].tag = tag;
                break;
            }
        }
        setNotes(newNotes);
    }else{
        console.log(json.errors);
    }
    }
    return (
        <NoteContext.Provider value={{ notes, setNotes, fetchallnotes, addnote, deletenote, editnote }}>
            {props.children}
        </NoteContext.Provider>
    )
}

export default NoteState
